<template>
  <div class="content new-profile">
    <div class="md-layout my-favorites" @click="selectArea($event)">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0"
        >
          <nav aria-label="breadcrumb" role="navigation">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: defaultScreen }"> Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Find-Companies
              </li>
            </ol>
          </nav>
        </div>
        <div class="md-layout md-gutter md-alignment-center-center">
          <!-- <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 profile-left-sec">
            <div>
              <h1 class="md-title profile-title title-font">Find Companies</h1>
            </div>
            <div>
              <small
                >Use these tools to find a company to profile or prospect
                list.</small
              >
            </div>
          </div> -->
          <!-- <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-25 md-xsmall-size-25 md-size-25 fin-pro-card">
                <profile-card class="toolbar-card">
                  <template slot="header">
                    <div class="toolbar-card-title">
                      <h5 class="title text-left">Price</h5>
                    </div>
                  </template>
                  <template slot="content">
                    <div class="info-wrap">
                      {{ splitPrice(price) }}
                    </div>
                  </template>
                </profile-card>
              </div>
              <div class="md-layout-item md-medium-size-30 md-xsmall-size-30 md-size-30">
                <profile-card class="toolbar-card">
                  <template slot="header">
                    <div class="toolbar-card-title">
                      <h5 class="title text-left">Companies</h5>
                    </div>
                  </template>
                  <template slot="content">
                    <div class="info-wrap">
                      {{ formatNumber(companiesCount) || 'N/A' }}
                    </div>
                  </template>
                </profile-card>
              </div>
              <div class="md-layout-item md-medium-size-25 md-xsmall-size-25 md-size-25">
                <template>
                  <router-link
                    :to="{ name: 'CompaniesList', params: { id: profileId } }"
                  >
                    <md-button
                      :disabled="isDisabled"
                      @click.native="access"
                      class="md-info md-block access-button"
                    >
                      Access List
                    </md-button>
                  </router-link>
                </template>
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <!-- <md-card class="welcome-card-wrap"> -->
      <div class="md-layout-item">
        <div class="md-layout-item">
          <div class="md-layout company_step">
            <!-- <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 p-0 find_step">
                    <md-dialog :md-active.sync="showIndustryDialog" class="dialog">
                      <md-dialog-content>
                        <md-tabs md-dynamic-height>
                          <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                            <industry-tab />
                          </div>
                        </md-tabs>
                      </md-dialog-content>
                    </md-dialog>
                      <div class="toolbar-card-title" @click="showIndustryDialog = true">
                        <h5 class="title text-left text-font">Industry</h5>
                      </div>
                      <div class="industry-market-info">
                        <div class="action-text" style="display: flex">
                          <md-icon
                            @click.native="resetIndustry($event)"
                            v-if="industry != null"
                            class="action-icon"
                            style="color: #0F66C5;"
                            >replay</md-icon
                          >
                          <span>
                              {{ industry ? `[${getData(industry)}]` : '' }}
                              {{
                                industry
                                  ? getName(industry)
                                  : 'Click here to select'
                              }}
                          </span>
                        </div>
                      </div>
                  </div> -->
            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 p-0 find_step"
            >
              <div class="toolbar-card-title" @click="selectedTab($event)">
                <h5 class="title text-left text-font">Industry</h5>
              </div>
              <div class="industry-market-info">
                <div class="action-text" style="display: flex">
                  <md-icon
                    @click.native="resetIndustry($event)"
                    v-if="industry != null"
                    class="action-icon"
                    style="color: #0F66C5;"
                    >replay</md-icon
                  >
                  <span>
                    {{ industry ? `[${getData(industry)}]` : '' }}
                    {{ industry ? getName(industry) : 'Click here to select' }}
                  </span>
                </div>
              </div>
              <div class="dropdownMenu">
                <nav-tabs-card no-label md-elevation="0">
                  <template slot="content">
                    <md-tabs md-alignment="left" id="finantialProfileTabs">
                      <industry-tab />
                    </md-tabs>
                  </template>
                </nav-tabs-card>
              </div>
            </div>
            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 p-0 find_step"
            >
              <div class="toolbar-card-title" @click="selectedTab($event)">
                <h5 class="title text-left text-font">Market Area</h5>
              </div>
              <div class="industry-market-info">
                <div class="action-text" style="display: flex">
                  <md-icon
                    @click.native="resetMarket($event)"
                    v-if="marketArea != null"
                    class="action-icon"
                    style="color: #0F66C5;"
                    >replay</md-icon
                  >
                  {{
                    marketArea ? getName(marketArea) : 'Click here to select'
                  }}
                </div>
              </div>
              <div class="dropdownMenu">
                <nav-tabs-card no-label md-elevation="0">
                  <template slot="content">
                    <md-tabs md-alignment="left" id="finantialProfileTabs">
                      <market-area-tab />
                    </md-tabs>
                  </template>
                </nav-tabs-card>
              </div>
            </div>
            <!-- <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 p-0 find_step">
                    <md-dialog :md-active.sync="showMarketDialog" class="dialog">
                      <md-dialog-content>
                        <md-tabs md-dynamic-height>
                          <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                            <market-area-tab />
                          </div>
                        </md-tabs>
                      </md-dialog-content>
                    </md-dialog>
                      <div class="toolbar-card-title" @click="showMarketDialog = true">
                        <h5 class="title text-left text-font">Market Area</h5>
                      </div>
                      <div class="industry-market-info">
                        <div class="action-text" style="display: flex">
                          <md-icon
                            @click.native="resetMarket($event)"
                            v-if="marketArea != null"
                            class="action-icon"
                            style="color: #0F66C5;"
                            >replay</md-icon
                          >
                          {{
                            marketArea
                              ? getName(marketArea)
                              : 'Click here to select'
                          }}
                        </div>
                      </div>
                  </div> -->
            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 p-0 range_bar"
            >
              <md-field>
                <label for="salesRangeFrom">Sales range from</label>
                <md-select
                  :disabled="industry == null"
                  v-model="salesRangeFrom"
                  name="salesRangeFrom"
                  id="salesRangeFrom"
                >
                  <md-option
                    v-for="[key, value] in Object.entries(salesRanges)"
                    :key="key"
                    :value="value"
                  >
                    {{ value }}
                  </md-option>
                </md-select>
              </md-field>
              <div class="range_info">
                <div class="action-text">
                  {{
                    salesRangeFrom ? salesRangeFrom : 'Select Industry First'
                  }}
                </div>
              </div>
            </div>
            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 p-0 range_bar"
            >
              <md-field>
                <label for="salesRangeTo">Sales range to</label>
                <md-select
                  :disabled="industry == null"
                  v-model="salesRangeTo"
                  name="salesRangeTo"
                  id="salesRangeTo"
                  value="select one"
                >
                  <md-option
                    v-for="[key, value] in Object.entries(salesRanges)"
                    :key="key"
                    :value="value"
                  >
                    {{ value }}
                  </md-option>
                </md-select>
              </md-field>
              <div class="range_info">
                <div class="action-text">
                  {{ salesRangeTo ? salesRangeTo : 'Select Industry First' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </md-card> -->
      <!--
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-50">
            <md-field>
              <label for="salesRangeFrom">Sales range from</label>
              <md-select
                :disabled="industry == null"
                v-model="salesRangeFrom"
                name="salesRangeFrom"
                id="salesRangeFrom"
              >
                <md-option
                  v-for="[key, value] in Object.entries(salesRanges)"
                  :key="key"
                  :value="key"
                >
                  {{ value }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-50">
            <md-field>
              <label for="salesRangeTo">Sales range to</label>
              <md-select
                :disabled="industry == null"
                v-model="salesRangeTo"
                name="salesRangeTo"
                id="salesRangeTo"
              >
                <md-option
                  v-for="[key, value] in Object.entries(salesRanges)"
                  :key="key"
                  :value="key"
                >
                  {{ value }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div
            class="alert md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-45"
            v-if="isRightSalesRange && notAvailable"
          >
            <span class="closebtn" @click="closeAlert">&times;</span>
            Please choose the right sales range.
          </div>
        </div>
      </div>-->
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 d-none"
      >
        <profile-steps />
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 fin-tab-list company_cardWpr"
      >
        <h1 class="section_header">Search Result</h1>
        <div class="md-layout companies_card">
          <div
            class="md-layout-item md-medium-size-60 md-xsmall-size-100 md-size-60 search_list"
          >
            <nav-tabs-card no-label md-elevation="0" class="m-0">
              <template slot="content">
                <md-tabs md-alignment="left" id="finantialProfileTabs">
                  <company-tab />
                  <!-- <related-products-tab /> -->
                </md-tabs>
              </template>
            </nav-tabs-card>
          </div>
          <div
            class="md-layout-item md-medium-size-40 md-xsmall-size-100 md-size-40 right_sec"
          >
            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-25 md-size-50 fin-pro-card p-0"
            >
              <profile-card class="toolbar-card">
                <template slot="header">
                  <div class="toolbar-card-title">
                    <h5 class="title text-left">Price</h5>
                  </div>
                </template>
                <template slot="content">
                  <div class="info-wrap">
                    {{ splitPrice(price) }}
                  </div>
                </template>
              </profile-card>
            </div>
            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-30 md-size-50 p-0"
            >
              <profile-card class="toolbar-card">
                <template slot="header">
                  <div class="toolbar-card-title">
                    <h5 class="title text-left">Companies</h5>
                  </div>
                </template>
                <template slot="content">
                  <div class="info-wrap">
                    {{ formatNumber(companiesCount) || 'N/A' }}
                  </div>
                </template>
              </profile-card>
            </div>
            <div
              class="md-layout-item md-medium-size-100 md-xsmall-size-25 md-size-100"
            >
              <template>
                <router-link
                  :to="{ name: 'CompaniesList', params: { id: profileId } }"
                >
                  <md-button
                    :disabled="isDisabled"
                    @click.native="access"
                    class="md-info md-block access-button"
                  >
                    Access List
                  </md-button>
                </router-link>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ProfileCard, NavTabsCard } from '@/components';
import IndustryTab from './_partials/IndustryTab.vue';
import MarketAreaTab from './_partials/MarketAreaTab.vue';
import CompanyTab from './_partials/CompanyTab.vue';
// import RelatedProductsTab from './_partials/RelatedProductsTab.vue';
import axios from 'axios';
import { mapState } from 'vuex';

import ProfileSteps from './_partials/ProfileSteps.vue';

export default {
  name: 'find-companies',
  components: {
    ProfileCard,
    NavTabsCard,
    IndustryTab,
    MarketAreaTab,
    CompanyTab,
    // RelatedProductsTab,
    ProfileSteps,
  },
  data() {
    return {
      isDisabled: true,
      salesRanges: [],
      salesRangeFrom: '',
      salesRangeTo: '',
      notAvailable: false,
      showIndustryDialog: false,
      showMarketDialog: false,
    };
  },
  async created() {
    await this.clearAll();
    await axios
      .get(process.env.VUE_APP_API_BASE_URL + '/info/salesFilters', {})
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          this.$store.commit('SET_ERROR_BIT', true);
          this.$store.commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/salesFilters" <br>`
          );
          throw new Error(
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
          );
        }
        let { filters } = res.data;
        this.salesRanges = filters;
      });
  },
  methods: {
    selectArea: function(e) {
      let parentDiv = document.querySelectorAll('.find_step');
      parentDiv.forEach(function(el) {
        el.classList.remove('open');
        el.addEventListener('click', function(e) {
          e.stopPropagation();
        });
      });
    },
    selectedTab: function(e) {
      let activeClass = e.target.parentElement;
      e.stopPropagation();
      if (activeClass.classList.contains('open')) {
        activeClass.classList.remove('open');
      } else {
        activeClass.classList.add('open');
        // activeClass.nextElementSibling.classList.remove("open");
      }
    },
    access: async function() {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/products/access',
          {},
          {
            params: {
              session_id: currentSession,
              product_id: this.profileId,
              companies: this.customizable ? JSON.stringify(this.locnums) : '',
              companyFilterType: this.customizable ? 'only' : '',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/products/access" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { access, location } = res.data;
        });
    },
    checkAccess: async function() {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/products/checkAccess',
          {},
          {
            params: {
              session_id: currentSession,
              product_id: this.profileId,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/products/checkAccess" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { access, ready } = res.data;
          if (ready && this.industry !== null) {
            this.isDisabled = false;
          } else {
            this.isDisabled = true;
          }
        });
    },
    formatNumber: function numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
    splitPrice: function(price) {
      if (price) {
        let priceStr = `${price}`;
        return (
          '$' +
          this.formatNumber(
            priceStr.includes('.') ? priceStr.split('.')[0] : price
          )
        );
      } else {
        return 'N/A';
      }
    },
    getData: function(name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }
    },
    getName: function(name) {
      return name.split('[')[0];
    },
    closeAlert: function() {
      this.notAvailable = false;
    },
    isRightSalesRange() {
      if (this.salesRangeFrom && this.salesRangeTo) {
        let result =
          parseInt(this.salesRangeFrom) < parseInt(this.salesRangeTo);
        this.notAvailable = !result;
        return result;
      }

      return false;
    },
    resetIndustry: async function(event) {
      event.stopPropagation();
      this.$store.commit('F_SET_INDUSTRY', null);

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/search_profiles/imr',
          {},
          {
            params: {
              session_id: currentSession,
              industry: '0',
              profile_id: this.profileId ? this.profileId : '0',
              type: 'imr',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_profiles/imr" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('F_SET_PROFILE_ID', id);
        });
    },
    resetMarket: async function(event) {
      event.stopPropagation();
      this.$store.commit('F_SET_MARKET_AREA', null);

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/search_profiles/imr',
          {},
          {
            params: {
              session_id: currentSession,
              area: 0,
              profile_id: this.profileId ? this.profileId : '0',
              type: 'imr',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_profiles/imr" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('F_SET_PROFILE_ID', id);
        });
    },
    clearAll: async function() {
      this.$store.commit('F_SET_PROFILE_ID', null);
      this.$store.commit('F_SET_INDUSTRY', null);
      this.$store.commit('F_SET_MARKET_AREA', null);
    },
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
    }),
    industry() {
      return this.$store.getters.fIndustry;
    },
    marketArea() {
      return this.$store.getters.fMarketArea;
    },
    price() {
      return this.$store.getters.price;
    },
    companiesCount() {
      return this.$store.getters.companiesCount;
    },
    industryDialog() {
      return this.$store.getters.industryDialog;
    },
    profileId() {
      return this.$store.getters.fProfileId;
    },
    locnums() {
      return this.$store.getters.locnums;
    },
    customizable() {
      return this.$store.getters.customizable;
    },
  },
  watch: {
    locnums() {
      this.checkAccess();
    },
    salesRangeFrom(newValue, oldValue) {
      this.$store.commit('SET_SALES_RANGE_FROM', newValue);
      this.isRightSalesRange();
    },
    salesRangeTo(newValue, oldValue) {
      this.$store.commit('SET_SALES_RANGE_TO', newValue);
      this.isRightSalesRange();
    },
    industryDialog(newValue, oldValue) {
      this.showIndustryDialog = newValue;
    },
    showIndustryDialog(value) {
      this.$store.commit('SET_INDUSTRY_DIALOG', value);
    },
  },
};
</script>
<style lang="scss">
.alert {
  background-color: #6839dd; /* Red */
  color: white;
  font-size: 0.8rem;
}
.closebtn {
  margin-left: 15px;
  color: white;
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}
.closebtn:hover {
  color: black;
}

.available-modal {
  color: #3c4858;
  font-size: 0.9375rem;
  cursor: pointer;
  transition: 0.5s;
  margin-right: 24px;
}

.available-modal:hover {
  color: #1a7bfa;
  transition: 0.5s;
}

.title-font {
  font-size: 2rem;
}

.text-font {
  font-size: 1.1rem;
  font-weight: bold;
}

.new-profile {
  margin-top: 20px;
}
.profile-left-sec {
  padding: 10px;
  padding-left: 30px !important;
}

.toolbar-card-title {
  h5 {
    cursor: pointer;

    .title-bold {
      color: #3b7ef1;
    }
  }
}

.industry-market-info {
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  text-align: left;
  white-space: nowrap;
}

.dialog {
  .md-dialog-container {
    cursor: pointer;
    margin-top: 110px;
    width: 65%;
    height: 80%;
  }
}

.industriy-market-box {
  display: flex;
  flex-direction: column;
}

.md-select-menu {
  margin: 57px 0 0 35px;
  box-shadow: 1px 1px 10px 1px rgb(0, 0, 0, 0.3);
  .md-list-item {
    .md-list-item-content {
      font-size: 13px;
    }
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
}
@media only screen and (max-width: 600px) {
  .fin-pro-card {
    margin-bottom: 10px;
  }
  .profile-left-sec {
    margin-bottom: 10px;
  }
  .fin-tab-list {
    margin-top: 350px;
  }
  #finantialProfileTabs .md-tabs-navigation {
    padding-left: 15px;
  }
}
@media screen and (max-width: 1280px) and (min-width: 600px) {
  .fin-tab-list {
    margin-top: 150px;
  }
}
</style>
